module.exports = __webpack_public_path__ + "img/img_passed@2x.26d68b3d.png";